<template>
	<div>
	  <div class="red_top_bg">
		<div
		  class="back_left"
		  @click="$router.back()"
		/>
		<div class="big_tit">
		  {{ $t('pagea.jfdh') }}
		</div>
	  </div>
	  <div style="">
		  <div style="padding-top: 10px;">
			  <van-tabs type="card" color="#1989fa" @click="changestate">
			    <van-tab :title="$t('pagea.wfh')">{{ $t('pagea.wfh') }}</van-tab>
			    <van-tab :title="$t('pagea.yfh')">{{ $t('pagea.yfh') }}</van-tab>
			  </van-tabs>
		  </div>
		  <van-list
			v-model="loading"
			:finished="finished"
			:finished-text="$t('pagea.mygdl')"
			@load="getdata"
		  >
			<div class="data_list">
				<div class="data_item" v-for="(item,index) in list" :key="index" @click="todetail(item)">
					<img class="data_img" :src="item.good_img"/>
					<div style="padding-left: 10px;">
						<div class="data_name">
							{{ item.goodname_lang }}
						</div>
						<div style="padding:5px 0;">
							<van-tag type="warning" v-if="item.state==1">{{ $t('pagea.wfh') }}</van-tag>
							<van-tag type="primary" v-if="item.state==2">{{ $t('pagea.yfh') }}</van-tag>
						</div>
						<div class="data_score">
							<van-icon name="underway-o" size="14"/>
							{{ parsetime(item.createtime)}}
						</div>
					</div>
				</div>
			</div>
		  </van-list>
	  </div>
	</div>
</template>

<script>
    import Fetch from '../../utils/fetch'
	import Vue from 'vue';
	import { List } from 'vant';
	import { Tag } from 'vant';
import { Tab, Tabs } from 'vant';
import { Icon } from 'vant';

Vue.use(Icon);

Vue.use(Tab);
Vue.use(Tabs);
	
	Vue.use(Tag);
	
	Vue.use(List);
	export default{
		data(){
			return{
				lang:this.$i18n.locale||"zh_cn",
				 list: [],
				  loading: false,
				  finished: false,
				page:1,
				state:1,
			}
		},
        created() {
            this.$parent.footer('user', false);
        },
		mounted() {
			
		},
		methods:{
			changestate(e){
				this.state=e+1;
				this.page=1;
				this.list=[];
				this.getdata();
			},
			getdata(){
				let self=this;
				Fetch('/index/getmygoods', {page: this.page,state:this.state}).then((res) => {
					let result=res.data;
					self.list=self.list.concat(res.data);
					// 加载状态结束
					self.loading = false;
					self.page++;
					// 数据全部加载完成
					if (result != 0) {
						self.finished = true;
					}
					if (result == 0&&self.page>1) {
						self.page--;
						self.finished = true;
					}
				});
			},
			parsetime(timestamp){//时间戳转日期格式
				var timelength=timestamp.toString().length;
				function add0(m){return m<10?'0'+m:m };
				var date=new Date(timestamp);
				if(timelength==10){
					date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
				}
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
				var D = date.getDate() + ' ';
				var h = add0(date.getHours()) + ':';
				var m = add0(date.getMinutes()) + ':';
				var s = date.getSeconds();
				return Y+add0(M)+add0(D)+h+m+s;
			},
		}
	}
	
</script>

<style lang="less" scoped>
	.data_list{
		display: flex;
		flex-wrap: wrap;
		padding: 10px;
	}
	.data_item{
		width: 100%;
		display: flex;
		align-items: center;
		padding: 10px;
		box-sizing: border-box;
		border-bottom: 1px solid #eee;
		.data_img{
			width: 64px;
		}
	}
	.data_name{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: #fff;
		font-size: 16px;
		padding: 5px 0;
		font-weight: bold;
	}
	.data_score{
		font-size: 14px;
		color: #999;
		font-weight: 600;
	}
</style>